import * as React from 'react';
import Button from '@telia-front/button';
import Icon from '@telia-front/icon';
import Separator from '@telia-front/separator';
import { TableCell } from '@telia-front/table';
const ChannelPriceTableCell = (props) => {
    const { price, width, variant = 'secondary', alignCenter } = props;
    const renderChannelPriceTableCellContent = () => {
        if (price.price) {
            if ('label' in price.price) {
                if (price.price.isIncluded === true) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Icon, { modifiers: "#check", size: "xs" }),
                        React.createElement("span", { className: "sr-only" }, price.price.label)));
                }
                else if (price.price.isIncluded === false) {
                    return React.createElement("span", { className: "sr-only" }, price.price.label);
                }
                else {
                    return React.createElement("p", null, price.price.label);
                }
            }
            else {
                return (React.createElement(React.Fragment, null,
                    price.label && (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "text-small" }, price.label),
                        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }))),
                    React.createElement(Button, Object.assign({}, price.price, { size: "small", variant: variant }))));
            }
        }
        return React.createElement("span", null, price.label);
    };
    return (React.createElement(TableCell, { width: width, className: `tv-comparison__price-cell${alignCenter ? ' text-center' : ''}`, valign: "middle" }, renderChannelPriceTableCellContent()));
};
export default ChannelPriceTableCell;
